export const REQUIRED_FIELD = 'Required field';
